import {
  DISCARD_TAB,
  HIGH_TAB,
  UNMARKED_TAB,
  useTask,
} from "@/stores/task";
import {
  showFailToast,
  showImagePreview,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import i18n from "@/locales";
import api from "@/modules/api";
import { sessionStorageGet } from "@/tools/sessionStorage";
import { useRawImageUrl } from "@/use/common";

export const isEditTraitAction = (task: Task, btn: string) =>
  !!(
    task.tab === "MateTrait" &&
    btn === "emoji" &&
    (task.entity as TextImage).mateTraitId
  );

/**
 * high 优质
 * emoji 存为新特征
 * brush 局部重绘
 * gif 生成动图
 * img1 存入相册
 * image 延展
 * delete 废弃
 * edit 编辑
 * info 编辑
 * more 更多
 *
 */
const taskMap: any = {
  MateTrait: {
    [UNMARKED_TAB]: {
      left: ["high", "emoji"],
      right: ["edit", "delete", "more"],
      more: ["brush", "img1", "image"],
    },
    [HIGH_TAB]: {
      first: ["info", "more"],
      more: ["emoji", "brush", "img1", "image", "delete"],
    },
    [DISCARD_TAB]: {
      first: ["edit", "high", "brush"],
    },
  },
  StoryImage: {
    [UNMARKED_TAB]: {
      left: ["high", "brush"],
      right: ["delete", "more"],
      more: ["emoji", "img1"],
    },
    [HIGH_TAB]: {
      first: ["img1", "more"],
      // second: ["emoji", "more"],
      more: ["brush", "image", "delete"],
    },
    [DISCARD_TAB]: {
      first: ["edit", "high", "brush"],
    },
  },
  StoryVideo: {
    [UNMARKED_TAB]: {
      left: ["high", "img1"],
      right: ["delete"],
    },
    [HIGH_TAB]: {
      first: ["img1", "more"],
      // second: ["delete"],
      more: ["delete"],
    },
    [DISCARD_TAB]: {
      first: ["high"],
    },
  },
  TextGif: {
    [UNMARKED_TAB]: {
      left: ["high", "img1"],
      right: ["delete"],
    },
    [HIGH_TAB]: {
      first: ["img1", "more"],
      // second: ["delete"],
      more: ["delete"],
    },
    [DISCARD_TAB]: {
      first: ["high"],
    },
  },
  TextImage: {
    [UNMARKED_TAB]: {
      left: ["high", "brush"],
      right: ["edit", "delete", "more"],
      more: ["emoji", "image", "img1"],
    },
    [HIGH_TAB]: {
      first: ["info", "more"],
      // second: ["emoji"],
      more: ["brush", "img1", "emoji", "image", "delete"],
    },
    [DISCARD_TAB]: {
      first: ["edit", "high", "brush"],
    },
  },
};

export const getTaskAction = (taskId: number, subTab: number, no: number) => {
  const task = useTask().taskMap.get(taskId);
  const entity = task!.entity as TextImage;
  const tab = task!.tab;
  const taskActions = taskMap[tab][subTab];
  let actionList: string[] = [];
  if (no === 0) actionList = taskActions.left || taskActions.first || [];
  if (no === 1) actionList = taskActions.right || taskActions.second || [];
  if (no === 2) {
    actionList = taskActions.more || [];

    actionList = actionList.concat([
      entity.isNotShown ? "eye-regular" : "eye-slash",
    ]);
  }
  if (entity.isNsfw) actionList = actionList.filter((item) => item !== "emoji");
  return actionList;
};

export const hideActionBtn = (taskId: number, item: string): boolean => {
  const task = useTask().taskMap.get(taskId);
  const entity = task!.entity as TextImage;
  if (["brush", "emoji"].includes(item) && entity.isNsfw) {
    return true;
  }

  return false;
};

export const clickBtn = async (btn: string, id: number) => {
  const taskStore = useTask();
  const toast = showLoadingToast({
    message: i18n.global.t("Message.progress"),
  });
  try {
    // 废弃
    if (btn === "delete") await taskStore.like(id, false);
    // 存入相册
    else if (btn === "img1") await taskStore.like(id, true, true);
    // 优质
    else if (btn === "high") await taskStore.like(id, true);
    // 生成动图
    else if (btn === "gif") {
      await taskStore.gif(id);
      showSuccessToast({ message: i18n.global.t("Message.taskAdded") });
    }
    // 生成宽图
    else if (btn === "image") await taskStore.wideImage(id);
    // 更多
    else if (btn === "more") {
      taskStore.activeTaskId = id;
      taskStore.showMoreActionModal = true;
    }
    // 编辑
    else if (btn === "edit" || btn === "info") {
      const tab = taskStore.getTab(id);
      if (tab === "TextImage") {
        const { mode, mateTraitId, mateTrait } = taskStore.getTask(id)
          ?.entity as TextImage;

        if (
          (mateTraitId && !mateTrait) ||
          sessionStorageGet("mateTraitDeleted:" + mateTraitId)
        ) {
          return showFailToast({
            message: i18n.global.t("Message.mateTraitNotExist"),
          });
        }

        if (mode === 1) {
          window.$router.push({ name: "imageGeneration", query: { id } });
        } else {
          window.$router.push({
            name: "imagePaintWithMode",
            query: { mode, id },
          });
        }
      } else if (tab === "MateTrait") {
        const {
          prompt,
          negativePrompt,
          style,
          sourceId,
          source,
          mode,
          customStyle,
          mixStyle,
        } = taskStore.getMedia(id) as TextImage;
        window.$router.push({
          name: "createTraitTask",
          query: {
            prompt: encodeURIComponent(prompt),
            negativePrompt: negativePrompt
              ? encodeURIComponent(negativePrompt!)
              : undefined,
            style: style ? style : undefined,
            sourceId,
            sourceUrl: source ? encodeURIComponent(source!.url) : undefined,
            mode,
            customStyle: customStyle
              ? encodeURIComponent(JSON.stringify(customStyle))
              : undefined,
            mixStyle: mixStyle
              ? encodeURIComponent(JSON.stringify(mixStyle))
              : undefined,
          },
        });
      }
    }
    // 存为新特征
    else if (btn === "emoji") {
      taskStore.activeTaskId = id;
      taskStore.showCreateTraitModal = true;
    }
    // 局部重绘
    else if (btn === "brush") {
      window.$router.push({
        name: "inpainting",
        query: { id },
      });
    } else if (btn === "download") {
      const task = taskStore.taskMap.get(id);
      const url = useRawImageUrl(task?.entity.media?.url!);
      url && showImagePreview([url]);
    } else if (btn === "eye-regular" || btn === "eye-slash") {
      const img = taskStore.taskMap.get(id)?.entity as TextImage;
      const { uuid, mediaId, isNotShown } = img;
      await api.updateTextImage(uuid, { mediaId, isNotShown: !isNotShown });
      img.isNotShown = isNotShown ? 0 : 1;
    }
    toast.close();
  } catch (e) {
    toast.close();
  }

  if (btn !== "more" && taskStore.showMoreActionModal) {
    taskStore.activeTaskId = id;
    taskStore.showMoreActionModal = false;
  }
};
